import Button from "@booking/components/atoms/forms/Button";
import { useState } from "react";

import { ColorEnum } from "@/enums";

import styles from "./CreateYourOwn.module.css";
import CreateYourOwnModal from "./CreateYourOwnModal";

interface CreateYourOwnCTAProps {
  courseNames?: string[];
  hotels?: Record<string, { name: string }>;
  venueName?: string;
  isEu?: boolean;
}

function CreateYourOwn(props: CreateYourOwnCTAProps) {
  const [showModal, setShowModal] = useState(false);
  const { courseNames = [], hotels = {}, venueName = "", isEu = false } = props;

  const openModal = () => {
    setShowModal(true);
  };

  return (
    <section className={styles.cyoSection}>
      <p>Create your own golf trip</p>
      <p>
        Can't find the experience you're looking for? Tell us what you like and
        our golf specialists will help make it happen.
      </p>
      <Button
        onClick={openModal}
        color={ColorEnum.STEELBLUE}
        data-gtm-category="Venue page"
        data-gtm-action="Create your own enquiry"
        data-gtm-label="Clicked"
      >
        Build my holiday
      </Button>
      <CreateYourOwnModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        courseNames={courseNames}
        hotels={hotels}
        venueName={venueName}
        isEu={isEu}
      />
    </section>
  );
}

export default CreateYourOwn;
